import type { DataLayerEvent } from '@magpie/ui-core';
import getCookieValue from './getCookieValue';
import logger from './logger';

const addSessionIdToEvent = (eventPayload: DataLayerEvent): DataLayerEvent => {
    const sessionIdKey = 'mmSessionId';
    let session = '';
    try {
        const sessionCookie = getCookieValue('mm_session_id');
        const decoded = decodeURIComponent(sessionCookie);
         
        session = decoded.split(';', 1)[0];
        if (!session) {
            logger.showLog('error', 'Session cookie not found');
        }
    } catch (error) {
        logger.showLog('error', error);
    }

     
    eventPayload = {
        ...eventPayload,
        [sessionIdKey]: session,
    };

    return eventPayload;
};

export default addSessionIdToEvent;
